import { useMemo } from 'react';
import { usePermissions } from '@/context/PermissionContext';
import { useAllTaskLists } from '@/hooks/task-lists/useTaskLists';
import { permissionKeys } from '@/utility';

export interface OnboardingTemplateOption {
  id: string;
  name: string;
}

/**
 * The company's active onboarding templates the Add employee form can
 * start, or an empty list when the viewer may not start one: that opens an
 * onboarding flow (`employee.update`) from a template
 * (`task_management.read`). Undefined while loading.
 */
export const useOnboardingTemplates = ():
  OnboardingTemplateOption[] | undefined => {
  const { permissions } = usePermissions();
  const canStart =
    permissions.has(permissionKeys.task_management.read) &&
    permissions.has(permissionKeys.employee.update);
  const { data } = useAllTaskLists(
    'onboarding',
    { status: 'active' },
    { enabled: canStart }
  );
  return useMemo(
    () =>
      canStart ? data?.data?.data?.map(({ id, name }) => ({ id, name })) : [],
    [canStart, data]
  );
};
